"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M10 2C11.657 2 13 3.343 13 5C13 6.657 11.657 8 10 8C8.343 8 7 6.657 7 5C7 3.343 8.343 2 10 2ZM17 15.0107C17 15.3227 16.894 15.6237 16.689 15.8607C16.059 16.5927 13.846 17.9997 10 17.9997C6.14 17.9997 3.929 16.5827 3.304 15.8527C3.104 15.6187 3 15.3227 3 15.0147V11.5717C3 10.1517 4.151 8.9997 5.571 8.9997H14.429C15.849 8.9997 17 10.1517 17 11.5717V15.0107Z",
    fill: "#727B7F"
  }));
};